import { render, staticRenderFns } from "./PhoneVerificationStatus.vue?vue&type=template&id=1f02171a"
import script from "./PhoneVerificationStatus.vue?vue&type=script&lang=js"
export * from "./PhoneVerificationStatus.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerificationStatus.vue?vue&type=style&index=0&id=1f02171a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports